var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"w-full flex py-base px-base items-center justify-center md:justify-start max-w-4xl"},[_c('a',{staticClass:"vx-logo w-6/12 md:w-3/12 lg:w-2/12 cursor-pointer",attrs:{"href":_vm.$enums.AppLinks.WEBSITE}},[_c('logo',{attrs:{"full":"","width":"100%"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }